import { Pagination } from '@src/api/types/pagination';
import PaginationComponent from '@src/components/Pagination';
import { useQueryParams } from '@src/hooks/useQueryParams';
import Th from '@src/ui/elements/table/Th';
import React from 'react';

import TagItem from './TagItem';

export interface TagItemType {
  id: number;
  name: string;
  enabled?: boolean | number;
  editable?: boolean | number;
}

interface TagTableProps<T> {
  items: TagItemType[];
  handleEditClick?: (item: T) => void;
  pagination: Pagination;
  handlePageChange: (page: number) => void;
}

const TagTable: React.FC<TagTableProps<TagItemType>> = ({ items, handleEditClick, pagination }) => {
  const { handleSort, handlePageChange, sort, direction } = useQueryParams({});
  return (
    <div>
      <table className='size-full table-fixed'>
        <thead>
          <tr className='border border-solid border-gray-200 bg-gray-50'>
            <Th
              className='w-[100px]'
              sortable
              sortOrder={sort === 'id' ? (direction as 'asc' | 'desc') : null}
              onClick={() => handleSort('id')}
            >
              ID
            </Th>
            <Th className='w-[70%]'>タグ名</Th>
            <Th
              className='w-[30%]'
              sortable
              sortOrder={sort === 'enabled' ? (direction as 'asc' | 'desc') : null}
              onClick={() => handleSort('enabled')}
            >
              ステータス
            </Th>
            <Th className='w-[130px]'>&nbsp;</Th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item) => (
              <TagItem
                key={item.id}
                item={item}
                handleEditClick={handleEditClick}
              />
            ))
          ) : (
            <tr>
              <td
                colSpan={4}
                className='py-4 text-center text-gray-500'
              >
                データがありません。
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {pagination.total > 0 && (
        <div className='mt-6'>
          <PaginationComponent
            pagination={pagination}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default TagTable;
